// Description: Endpoint to retrieve customer sentiment analysis
// Updated: 08/09/2025
// Author: Simon Franklin

import axios from 'axios';
import { getTokenData } from '../../../shared/utils/utils';

export async function SentimentsAnalysis(data) {
  try {
    const { token, client_id } = await getTokenData();

    if (!token) throw new Error('Token de autenticação não encontrado');
    if (!client_id) throw new Error('ID do cliente não encontrado');

    const response = await axios.post(
      'https://api.123zap.com.br/webhook/ai/analysis/sentiments',
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
          'Client_ID': client_id,
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error('Erro ao obter dados da API:', error);

    if (error.response) {
      return {
        data: null,
        status: error.response.status,
        message: error.response.data?.error || 'Erro no servidor.',
      };
    } else {
      return {
        data: null,
        status: 500,
        message: 'Ocorreu um erro na requisição.',
      };
    }
  }
}